/**
 * Map configuration. Uses local PMTiles (public/edc-mexico.pmtiles) by default.
 * Run npm run pmtiles:extract to create the file if missing.
 */
export const DEFAULT_REGION_ID = 'edc-mexico';

/** Default map center [lng, lat] for EDC venue when no stage is selected. */
export const DEFAULT_MAP_CENTER: [number, number] = [
  -99.08533354861581,
  19.40156556335134,
];

export const PMTILES_LOCAL_FILENAME = 'edc-mexico.pmtiles';

/**
 * Returns same-origin URL for the local PMTiles file (default map source).
 */
export function getLocalPmtilesUrl(origin: string): string {
  return `${origin}/${PMTILES_LOCAL_FILENAME}`;
}
